/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-toaster',
  standalone: true,
  imports: [CommonModule, ToastModule],
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
})
export class ToasterComponent {
  constructor(private messageService: MessageService) {}

  success(title: string, text: string) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'success',
      summary: title,
      detail: text,
    });
  }

  info(title: string, text: string) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'info',
      summary: title,
      detail: text,
    });
  }

  warn(title: string, text: string) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'warn',
      summary: title,
      detail: text,
    });
  }

  error(title: string, text: string) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'error',
      summary: title,
      detail: text,
    });
  }
}
